<template>
  <el-popover
    v-model="visible"
    :placement="placement"
    :width="popWidth"
    :disabled="disabled || popoverDis"
    trigger="click"
    popper-class="treePopover"
    @show="popoverShow"
  >
    <div
      @mouseenter="enterTree"
      @mouseleave="leaveTree"
    >
      <div
        :class="'el-input--' + inputSize"
        style="margin-bottom: 10px"
        v-if="search"
      >
        <input
          class="el-input__inner"
          style="height: 34px"
          type="text"
          placeholder="输入关键字进行过滤"
          :value="filterText"
          @input="filterInput"
          @keydown.enter="filterTree"
        />
      </div>
      <el-scrollbar>
        <div :style="{ maxHeight: maxHeight + 'px', paddingRight: '12px' }">
          <operate-tree
            ref="tree"
            v-on="$listeners"
            v-bind="$attrs"
            v-model="selected"
            :api-url="apiUrl"
            :is-init="isInit"
            :is-portal="isPortal"
            :reload="reload"
            :disabled="disabled"
            :addData="addData"
            :emptyText="emptyText"
            :parent-id="parentId"
            :filter-text="filterText"
            :is-async="isAsync"
            :multiple="multiple"
            :default-props="defaultProps"
            :check-strictly="checkStrictly"
            :options.sync="options"
            :visible.sync="visible"
            :query="query"
            :noLabs="value && !labs"
            :isRemoteSearch="isRemoteSearch"
            :remoteSearchUrl="remoteSearchUrl"
            :remoteSearchKey="remoteSearchKey"
            @getAllCheck="getAllCheck"
            @select="select"
            @input="input"
          />
        </div>
      </el-scrollbar>
    </div>
    <el-select
      v-model="selected"
      slot="reference"
      :disabled="disabled"
      :multiple="multiple"
      :size="selectSize"
      :placeholder="placeholder"
      :clearable="clearable"
      readonly
      class="treeElSelect"
      popper-class="treeSelect"
      ref="selectRef"
      @blur="selectBlur"
      @remove-tag="removeTag"
      @clear="clearSelected"
      @change="selectChange"
    >
      <!-- style="width: 100%" -->
      <el-option
        v-for="(item, index) in options"
        :key="item[defaultProps.id] + '_' + index"
        :label="item[defaultProps.label]"
        :value="item[defaultProps.id]"
      />
    </el-select>
  </el-popover>
</template>

<script>
import OperateTree from "./OperateTree";

// 树形结构选中组件
export default {
  name: "TreeSelect",
  components: { OperateTree },
  props: {
    // 双向绑定数据，外部v-model绑定使用
    value: {
      type: [String, Number, Array],
      default: null,
    },
    // 传入选择框回显数据源
    labs: {
      type: [String, Array],
      default: null,
    },
    apiUrl: {
      //树形结构接口地址
      type: String,
      default: "",
    },
    placement: {
      type: String,
      default: "bottom",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 传入组件宽度
    width: {
      type: Number,
      default: null,
    },
    // 选择框尺寸
    selectSize: {
      type: String,
      default: "",
    },
    maxHeight: {
      //最大高度
      type: Number,
      default: 240,
    },
    // 外部传入数据，添加至树形结构最外层
    addData: {
      type: Array,
      default() {
        return [];
      },
    },
    // 树组件配置
    defaultProps: {
      type: Object,
      default() {
        return {
          id: "id",
          label: "deptName",
          children: "children",
          isLeaf: (data) => {
            return data.childNum === 0;
          },
        };
      },
    },
    // 父子不互相关联
    checkStrictly: {
      type: Boolean,
      default: false,
    },
    // 是否可以清空
    clearable: {
      type: Boolean,
      default: false,
    },
    // 是否可以搜索
    search: {
      type: Boolean,
      default: true,
    },
    // 父节点id，用于异步树查询下级树节点数据
    parentId: {
      type: [String, Number],
      default: "",
    },
    // 是否初始化请求树节点数据，部分情况需要上一项选择完毕之后请求
    isInit: {
      type: Boolean,
      default: true,
    },
    // 是否异步请求数据
    isAsync: {
      type: Boolean,
      default: true,
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    reload: {
      type: Boolean,
      default: false,
    },
    isPortal: {
      type: Boolean,
      default: true,
    },
    emptyText: {
      type: String,
      default: "暂无数据",
    },
    isRemoteSearch: {
      //下拉框中搜索是否为调用接口远程搜索
      type: Boolean,
      default: false,
    },
    remoteSearchUrl: {
      //下拉框中远程搜索接口
      type: String,
      default: "",
    },
    remoteSearchKey: {
      //下拉框中远程搜索参数名
      type: String,
      default: "keyWord",
    },
  },
  data() {
    return {
      selected: this.value,
      visible: false,
      filterText: "", // 筛选框绑定值
      popWidth: "auto", // 下拉框宽度
      options: [], // 选择框下拉数据
      popoverDis: false, // 表单禁用选项
      key: Math.round(Math.random()),
      keyFlag: false,
      isEnter: false,
    };
  },
  mounted() {
    this.getOptions();
    this.$nextTick(() => {
      // 设置下拉选择框默认宽度
      let inputWidth = this.$refs.selectRef.inputWidth;
      this.popWidth = this.width
        ? this.width
        : inputWidth > 150
        ? inputWidth
        : "auto";
      if (!this.disabled) {
        this.getDisable();
      }
    });
  },
  computed: {
    // 筛选框尺寸
    inputSize() {
      if (this.selectSize) {
        return this.selectSize;
      } else {
        return this.$parent.elFormItemSize;
      }
    },
  },
  watch: {
    // 监听双向绑定值给组件赋值
    value(val) {
      this.keyFlag = true;
      this.selected = val;
      if (val && this.labs) {
        this.getOptions();
      }
    },
    reload(val) {
      if (val) {
        this.filterText = "";
      }
    },
    labs: {
      // immediate:true,
      deep: true,
      handler() {
        this.getOptions();
      },
    },
    visible(val) {
       if (!val) {
        this.filterText = "";
      }
    }
  },
  methods: {
    /**监测表单禁用 */
    getDisable() {
      if (this.$parent.form) {
        this.popoverDis = this.$parent.form.disabled;
      }
    },
    // 筛选树节点
    filterInput(e) {
      this.filterText = e.target.value;
    },
    /**远程搜索树节点 */
    filterTree() {
      if (this.isRemoteSearch) {
        this.$refs.tree.getOperateTree();
      }
    },
    // 移除选中事件
    removeTag(val) {
      this.$refs.tree.setNodeChecked(val, false);
    },
    // 获取下拉框回显数据源
    getOptions() {
      if (!this.value || this.value.length === 0) return;
      let options = [];
      let option = {};
      if (this.multiple) {
        let flag = false;
        this.options.forEach((el, elIndex) => {
          if (this.value.includes(el[this.defaultProps.id])) {
            flag = true;
          }
        });
        if (!flag) {
          this.value.forEach((item, index) => {
            option = {};
            option[this.defaultProps.id] = item;
            option[this.defaultProps.label] = this.labs[index];
            options.push(option);
          });
          this.options = options;
        }
      } else {
        option[this.defaultProps.id] = this.value;
        option[this.defaultProps.label] = this.labs;
        options = [option];
        this.options = options;
      }
    },
    /**获取树形组件的ref */
    getTreeRef() {
      return this.$refs.tree.$refs.tree;
    },
    // 清空多选框及树节点选中数据
    clearSelected() {
      this.$emit("clear");
      this.$refs.tree.clearSelected();
    },
    // 获取当前所有选中树节点key
    getAllCheck(allKey) {
      this.$emit("getAllCheck", allKey);
    },
    // 映射双向绑定值
    input(val) {
      this.$emit("input", val);
    },
    selectBlur() {
      if (!this.isEnter) {
        this.visible = false;
      }
    },
    enterTree() {
      this.isEnter = true;
    },
    leaveTree() {
      this.isEnter = false;
      this.$refs.selectRef.focus();
    },
    /**
     * 当前选中树节点对象
     * @param node 节点对象
     */
    select(node) {
      this.$emit("select-node", node);
    },
    // 组件popover显示的时候
    popoverShow() {
      this.filterTree();
      this.$emit("popoverShow", true);
    },
    // select选择框事件
    selectChange() {
      this.$emit("input", this.selected);
    },
  },
};
</script>
<style lang="scss">
.treePopover {
  // transform: translateX(-10px);
  .el-tree-node > .el-tree-node__children {
    overflow: visible;
  }
}
.treeSelect {
  display: none !important;
}
</style>
